import { pickT } from "@repo/shared";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { T } from "./page.i18n";

type SupportedLocale = keyof typeof T;

export default function ThankYouPage() {
  const [clientName, setClientName] = useState<string | null>(null);
  const [lang, setLang] = useState<SupportedLocale>("en_GB");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get client info and language from session storage (set before redirect)
    const name = sessionStorage.getItem("publicClientName");
    const storedLang = sessionStorage.getItem("publicFlowLanguage") as SupportedLocale | null;
    setClientName(name);
    if (storedLang && (storedLang === "en_GB" || storedLang === "nb_NO")) {
      setLang(storedLang);
    }
    setLoading(false);

    // Clean up session after displaying
    sessionStorage.removeItem("publicClientName");
    sessionStorage.removeItem("publicFlowLanguage");

    // Clear public auth so next link visit requires re-authentication
    localStorage.removeItem("publicSessionToken");
    localStorage.removeItem("publicSessionToken_for");
  }, []);

  const t = pickT(T, lang);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto w-16 h-16 bg-success/20 rounded-full flex items-center justify-center mb-4">
            <CheckCircle2 className="w-10 h-10 text-success" />
          </div>
          <CardTitle className="text-3xl">{t.thankYou}</CardTitle>
          <CardDescription className="text-lg mt-2">{t.submittedSuccessfully}</CardDescription>
        </CardHeader>

        <CardContent className="text-center space-y-6">
          <div className="space-y-2">
            {clientName && <p className="text-lg">{t.thankYouName(clientName)}</p>}
            <p className="text-muted-foreground">{t.responsesSaved}</p>
          </div>

          <p className="text-sm text-muted-foreground pt-4">{t.closeWindow}</p>
        </CardContent>
      </Card>
    </div>
  );
}
